import React from 'react';
import { motion } from 'framer-motion';
import { Crosshair, CheckCircle2 } from 'lucide-react';
export function ADAS() {
  return <section className="py-16 lg:py-24 bg-white" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-15">
            <div className="w-12 h-12 bg-brand-light rounded-xl flex items-center justify-center mb-6" data-id="element-16">
              <Crosshair className="w-6 h-6 text-brand-blue" data-id="element-17" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-18">
              Windshield Replacement with On-Site ADAS Calibration
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-19">
              Many modern vehicles use cameras and sensors mounted near the
              windshield for driver-assistance features. After windshield
              replacement, those systems may need recalibration so features like
              lane departure warning, adaptive cruise control and automatic
              emergency braking work correctly.
            </p>
            <a href="#quote" className="inline-flex items-center text-brand-blue font-bold hover:text-brand-hover transition-colors group" data-id="element-20">
              Get a Free Quote with ADAS Calibration
              <span className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-21">
                →
              </span>
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-slate-50 rounded-2xl p-8 border border-slate-100" data-id="element-22">
            <h3 className="text-xl font-bold text-navy-900 mb-6" data-id="element-23">
              Why Calibration Matters
            </h3>
            <ul className="space-y-5" data-id="element-24">
              {['Windshield replacement and ADAS recalibration handled in one place', 'Trained technicians and precise calibration equipment', 'Helps reduce downtime and extra appointments', 'Supports safety systems after replacement'].map((point, i) => <li key={i} className="flex items-start gap-4" data-id="element-25">
                  <div className="w-6 h-6 rounded-full bg-white shadow-sm flex items-center justify-center shrink-0 mt-0.5" data-id="element-26">
                    <CheckCircle2 className="w-4 h-4 text-brand-blue" data-id="element-27" />
                  </div>
                  <span className="text-slate-700 font-medium" data-id="element-28">{point}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}